
import { Image, Article, Section, DocsIntro, DocsHeader, SectionHeader, DocsHeading } from './extra/Components';
import { Content } from "./extra/Components";

import { Intro, introQuiz, introHeader, sff, klubbenSection, riskSection, introKrav, introAff, introKostnad, introQuizSection } from "./sections/Intro";

import {
    Material, materialQuiz, materialRigg, materialSkarm,
    materialKring,
    materialTrering,
    materialReserv,
    materialAAD,
    materialRSL,
    materialBrostrem,
    materialBromsar,
    materialElevriggar,
    materialPackcert,
    materialSelfcheck,
    materialQuizSection,
} from "./sections/Material";

import {
    Faltet, faltetFlygplanet, faltetHangar, faltetHeader, faltetIlastning, faltetKlubbstuga, faltetNodhopp, faltetQuizSection,
    faltetBanor,
    faltetLandningsomraden,
    faltetVindriktning,
    faltetHl,
    faltetHlT,
} from './sections/Faltet';

import {
    Hoppet, frifalletsPri, hoppetAff1, hoppetDrag, hoppetHojd, hoppetTecken, hoppetUthopp,
    hoppetSpotting,
    hoppetHeading,
    hoppetMoln,
    hoppetQuizSection
} from './sections/Hoppet';

import {
    UnderSkarm, skarmQuiz, underSkarmHurFlyger, underSkarmTaSigHem, underSkarmTurbulens, underSkarmLekområde, underSkarmMoln, underSkarmKommunikation, underSkarmQuizSection,
    underSkarmKallotdrill
} from './sections/Underskarm';

import { Felfunktioner, felfunkBeslutshojd, felfunkBraFallskärm, felfunkHogfarLagfart, felfunkIntro, felfunkKniv, felfunkKända, felfunkOrsaker, felfunkReservdrag, felfunkSelprov,
    felfunkQuizSection
 } from './sections/Felfunkioner';

import { Landning, landningBargning, landningFlar, landningIntro, landningQuizSection, landningRiktning, landningRullning, landningUte, LandningVarv } from './sections/Landning';

import { Packning, packingKontroller, packningIntro, packningManualer } from './sections/Packning';

import { Aff, AffLevel, affLevels,
    affMoment, affQuizSection
 } from './sections/Aff';

import { StorQuiz, storQuizSection } from './sections/Storquiz';

import ALicens from './sections/Alicens';

import Vidare from './sections/Vidare';

import {
    faListCheck,
    faTools,
    faMapSigns,
    faHandPointLeft,
    faPersonThroughWindow,
    faSkullCrossbones,
    faPersonFalling,
    faParachuteBox,
    faPlaneArrival,
    faKitMedical,
    faBoxesPacking,
    faInfo,
    faDiceOne,
    faDiceTwo,
    faDiceThree,
    faDiceFour,
    faDiceFive,
    faDiceSix,
    faTrophy,
    faTriangleExclamation,
    faLayerGroup,
    faUserGroup,
    faFolderOpen,
} from '@fortawesome/free-solid-svg-icons';

//import affExit from './assets/1 intro/4 klubben-small.jpg';
import affExit from './assets/4 hoppet/10 aff exit-small.jpg';
import aff1 from './assets/4 hoppet/11 aff 1 i firfall-small.jpg';
import flygaSkarm from './assets/5 fallskarm/8 flyga fallskärm-small.jpg'

import ova from './assets/10 drillande/2 öva-small.jpg'

import packande from './assets/8 packning/2 packaJobbigt-small.jpg';

import monkey from './assets/6 felfunk/felfunks/12 monkey fist-small.jpg';



const SydUspa = ({ section, setSection, article, setArticle, club, setClub, targets }) =>
(<Content section={section} article={article} setArticle={setArticle} oneBig={false} club={club} setClub={setClub}>
    {/** {TodoKort(targets)} **/}
    <Article id="introduktionkort" icon={faMapSigns} name="Intro" setArticle={setArticle} setSection={setSection} >
        <Section id="cat" name="Category A altitude" skipBorder={true}>
            <p>
                Förbundet

                Hur utbildningen funkar

                Krav hälsa och så
            </p>
            <p>
                cat a på riktigt
                
                1 hopp


            -- Flygplanet
                hur att använda en fallskärm. dra, kutt och reserv

                höjdmätare och höjder

                I och run planet, nödlandning, nödhopp
                Våda i planet

            --Frifall
                Frifallsställning - svank
                Arm och ben position / symmetri

                Uthopp

                Drag

                Tecken

                Frifallets prioriteter

                Hitta handtaget

                Fördröjning

            -- skärm
                Kallotdrill

                Beslutshöjd

                Driftstörningar

                dubbla fallskärmar

            -- Landning
                Varv

                Vindriktning

                Medvindslandning jämfört med låg sväng

                Flär och rullning

                Hur att hantera:
                    - Kraftledning
                    - vatten
                    - Träd
                    - Byggnad
                    - Hoppzonsspecifika hinder.

            -- Plugg?
                Skärmens delar

            
            -- Hopp 1 program

                exit

                oc

                tre dummydrag

                OC

                6000' 1828 m lock on

                5500' 1676 m  drag

                Kallotdrill

                orientering

                flyga varv

                Flär och rullning
            </p>
        </Section>

        <Section id="catb" name="Category B basics" skipBorder={true}>
            <p>
                1 hopp

                markvind och höjdvind, skråande luft riktning mot markriktning

                klura ut lekområde

                planets finalriktning

                Kolla efter andra skärmar

                Hur skärmen reagerar på en flär och varför vi inte backar. Cykling efter input

                Mer rullning

                Separering av luftrum mellan skärmar och flygplan. 


                -- Hopp 2 program

                Exit

                OC

                1 Dummy drag

                HAALR - heading, altitude, arch, legs, relax

                Sträck benen i tre sekunder

                HAALR

                Svängar

                6000' feet lock on

                5500' drag

                Kallotdrill

                orientering

                flyga varv

                Flär och rullning
            </p>
        </Section>

                <Section id="catb" name="Category C control" skipBorder={true}>
            <p>
                2 hopp


                Om i kontroll fortsätt hoppet

                Hur att vända sig från ryggläge. Ryggbox. in med en arm. Kom runt.

                Wing loading

                Turbulens 

                

                Kallotdrill

                orientering

                flyga varv

                Flär och rullning
            </p>
        </Section>

        <Section id="eslövsflygfällt" name="Eslövs flygfällt" skipBorder={true}>
            {faltetHeader}
            {/** faltetBanor **/}
            {faltetHangar}
            {faltetKlubbstuga}
        </Section>
        {riskSection}

    </Article>



</Content>);




const TodoKort = ({ setSection, setArticle }) => (
    <Article name="Att göra listan från chatten" icon={faListCheck} id="attgora" setArticle={setArticle} setSection={setSection}>
        <DocsHeader >
            <h1 className="docs-heading">Kortkurs, Kursupplägg 8h <span className="docs-time">Last updated:
                2026-03-25</span>
            </h1>
            <DocsIntro>
            </DocsIntro>
        </DocsHeader >
        <Section id="Kursupplägg" name="Kursupplägg" >
            <p>
                Intro och  hälsa och säkerhet (45min)
            </p>
            <ul>
                <li>
                    Kort om oss, Kort om er
                </li>
                <li>
                    Kort om fältet vi är på
                </li>
            </ul>
        </Section>
        <Section id="Utrustning" name="Utrustning" >
            <p>
                Utrustning (90 min)
            </p>
            <ul>
                <li>
                    Ganska grundlig genomgång
                </li>
                <li>
                    Repetera! Postit-övning
                </li>
            </ul>
        </Section>
        <Section id=" Dra fallskärmen " name=" Dra fallskärmen " >
            <p>
                Dra fallskärmen (30 min)
            </p>
            <ul>
                <li>
                    Visa, träna drag
                </li>
                <li>
                    Prata draghöjd
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med!
                </li>
                <li>
                    Träna kasta pilot i riktig elevrigg
                </li>
            </ul>
        </Section>
        <Section id="Felfunktioer" name="Felfunktioer" >
            <p>
                Felfunktioner (30 min)
            </p>
            <ul>
                <li>
                    Prata harddeck. 1000m. Sparka snodd. Två flär.
                </li>
                <li>
                    Is it there? Is it square? does it flare?
                </li>
                <li>
                    Prata om hög- låg och felfunkisar. filmer tar vi sen. Vad tittar man efter?
                </li>
            </ul>
        </Section>
        <Section id="Exit" name="Exit" >
            <p>
                Exit (30 min)
            </p>
            <ul>
                <li>
                    Prata exit
                </li>
                <li>
                    Prata om i och runt flygplanet
                </li>
                <li>
                    Prata nödhopp
                </li>
            </ul>
        </Section>
        <Section id="Första hoppet" name="Första hoppet" >
            <p>
                Första hoppet (45 min)
            </p>
        </Section>
        <Section id="Flyga fallskärm" name="Flyga fallskärm" >
            <p>
                Flyga fallskärm (30 min)
            </p>
            <ul>
                <li>

                    Prata trafikvarv
                </li>
                <li>
                    Prata väjningsplikt
                </li>
                <li>
                    Prata styr- och bromsdon
                </li>
                <li>
                    Prata om att landa sin fallskärm
                </li>
                <li>
                    Turbulent och termik
                </li>
            </ul>
        </Section>
        <Section id="Landa" name="Landa" >
            <p>
                Landa (30 min)
            </p>
            <ul>
                <li>
                    Rulla
                </li>
                <li>
                    Landa utanför hoppfältet
                </li>
            </ul>
        </Section>
        <Section id="Reservdrag" name="Reservdrag" >
            <p>
                Reservdrag/sele (30 min)
            </p>
            <ul>
                <li>
                    Visa och träna drag
                </li>
                <li>
                    Dummy!
                </li>
                <li>
                    sparka snodd. rimligt scenario första hoppen.
                </li>
                <li>
                    Viktig färdighet att känna sig trygg med.
                </li>
            </ul>
        </Section>
        <Section id="Packing" name="Packing" >
            <p>
                Packing (rep. utrustning) (30 min)
            </p>
            <ul>
                <li>
                    Visa packning
                </li>
                <li>
                    Passa på att repetera utrustningens delar
                </li>
            </ul>
        </Section>
        <Section id="filmer" name="filmer" >
            <p>
                Gemensamma filmer av felfunktioner och sånt (90 min)
            </p>
            <ul>
                <li>
                    Filmer
                </li>
                <li>
                    Kaffe
                </li>
                <li>
                    Diskussioner
                </li>
            </ul>
        </Section>
    </Article >);

export { SydUspa };